import { Skeleton } from "@/components/Skeleton";

interface TextSkeletonProps {
  /** Number of lines to display */
  lines?: number;
  /** Width of the text (default: "100%") */
  width?: string | number;
  /** Width of the last line (useful for multi-line text) */
  lastLineWidth?: string | number;
  /** Height of each line (default: "1rem") */
  lineHeight?: string | number;
  /** Gap between lines (default: "0.5rem") */
  gap?: string;
  /** Custom className */
  className?: string;
}

/**
 * TextSkeleton Component
 * Skeleton for text content with support for multiple lines
 */
export const TextSkeleton = ({
  lines = 1,
  width = "100%",
  lastLineWidth,
  lineHeight = "1rem",
  gap = "0.5rem",
  className,
}: TextSkeletonProps) => {
  if (lines === 1) {
    return <Skeleton width={width} height={lineHeight} variant="text" className={className} />;
  }

  return (
    <div className={className} style={{ display: "flex", flexDirection: "column", gap }}>
      {Array.from({ length: lines }).map((_, index) => {
        const isLastLine = index === lines - 1;
        const lineWidth = isLastLine && lastLineWidth ? lastLineWidth : width;
        return <Skeleton key={index} width={lineWidth} height={lineHeight} variant="text" />;
      })}
    </div>
  );
};

TextSkeleton.displayName = "TextSkeleton";
